import { render, staticRenderFns } from "./returnDetail.vue?vue&type=template&id=f2511dc6&scoped=true"
import script from "./returnDetail.vue?vue&type=script&lang=js"
export * from "./returnDetail.vue?vue&type=script&lang=js"
import style0 from "./returnDetail.vue?vue&type=style&index=0&id=f2511dc6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2511dc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2511dc6')) {
      api.createRecord('f2511dc6', component.options)
    } else {
      api.reload('f2511dc6', component.options)
    }
    module.hot.accept("./returnDetail.vue?vue&type=template&id=f2511dc6&scoped=true", function () {
      api.rerender('f2511dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wareHouse/returnDetail.vue"
export default component.exports